<template>
    <section class="questionwrapper">
      <div class="helper-holder">
        <p>Convert a binary</p>
        <!--<input v-model="binaryInputC" @keyup="binaryToDec" type="number" id="input-question2"/>-->
        <!--<input v-model="binaryInputC" type="number" id="input-question2"/>-->

        <!--Måste ha @keyup="binaryToDec för att kolla för varje förändring av tecken."-->
        <!--<input v-model="binaryInputC" @keyup="binaryToDec" @keyup.enter="enterPressed" type="number" id="input-question2"/>-->
        <input v-model="binaryInputC" @keyup="keymonitor" type="number" id="input-question2"/>
        <label for="input-question2">Enter a binary</label>

        <p>to a decimal number</p>
        <!--<p>{{   }} är binaryInput och det som skrivs in. Men om man vill använda det måste man även ha en specifik metod och använda @.</p>-->
        </div>
    </section>
</template>

<script>
export default {
  data: function () {
    return {
      // binaryInput: ''
      binaryInputC: '',
      hasAnsweredC: false,
      enterPressedC: false,
      myEvent: { key: '' }
    };
  },

  methods: {
    // https://www.binaryhexconverter.com/binary-to-decimal-converter
    // https://www.binaryhexconverter.com/binary-to-hex-converter
    binaryToDec: function () {
      // console.log(this.binaryInput);
      // kontrollera att det är ett binärt tal
      // lägg alla siffror i en array
      const binaryArray1 = [...this.binaryInputC];

      // omvandla till siffror från ['1', '0']
      const binaryArray = binaryArray1.map(function (item) {
        return parseInt(item, 10);
      });

      // gå igenom arrayen och kontrollera att den bara innehåller 1:or eller 0:or
      const checkedArray = binaryArray.filter(num => num === 1 || num === 0);

      if (binaryArray.length === checkedArray.length) {
        // gör omvandling från binärt till decimalt
        // 10
        // 0*2 + 1
        // 1*2 +0  =2
        // (previous total * 2) +
        const questionAnswer = binaryArray.reduce(function (accumulator, currentValue, currentIndex, array) {
          // console.log('accumulator: ' + accumulator + ', currentValue: ' + currentValue + ', currentIndex: ' + currentIndex + ', array: ' + array);
          return (accumulator * 2) + currentValue;
        }, 0);

        // console.log('binaryToDec in AppQuestion3.vue says questionAnswer is: ' + questionAnswer);

        const answerObject = {
          binary: this.binaryInputC,
          answer: questionAnswer,
          error: 0
        };

        // this.updateButtonC();
        this.$emit('enable-button', true);
        this.$emit('update-answer-two', answerObject);

        return answerObject;
        // return this.binaryInputC;
      } else {
        // console.log('ej binärt');
        const answerObject = {
          binary: null,
          answer: 'No binary',
          error: 1
        };
        this.$emit('enable-button', false);
        this.$emit('update-answer-two', answerObject);
        return answerObject;
      }
      // spotta ut felmeddelande om att det inte är ett binärt tal
    },
    /* updateButtonC: function () {
      // även emittera att det är ok att enabla knappen
      this.hasAnsweredC = true;
      const answerC = this.hasAnsweredC;
      this.$emit('enable-button', answerC);
      console.log('updateButtonC in AppQuestion3.vue: ' + this.hasAnsweredC);
      console.log('updateButtonC in AppQuestion3.vue: emitted value is: ' + answerC);
      return answerC;
    } */
    /*  enterPressed: function () { // skicka info om att användaren tryckt enter
      this.enterPressedC = true;
      this.$emit('enter-pressed-emit', this.enterPressedC);
      console.log('enterPressed in AppQuestion3');
      return this.enterPressedC;
    } */
    /*  enterPressed: function () {
      console.log('enterPressed in AppQuestion3');
      this.enterPressedC = true;
      this.$emit('enter-pressed-emit', this.enterPressedC);
    }, */
    keymonitor: function (event) { // viktigt att lägga in event i watchdeklarationen av keymonitor
      this.myEvent = event;
      /* console.log('event: ');
      console.log(event);
      console.log('my event: ');
      console.log(this.myEvent); */

      // om det är mellanslag eller om man har suddat ut t.ex. 22 och det inte står någonting
      if (event.keyCode === 32 || this.binaryInputC.length <= 0) {
        // gör inget
      } else if (event.key === 'Enter') {
        this.binaryToDec();
        // console.log('enterPressed in AppQuestion3');
        this.enterPressedC = true;
        this.$emit('enter-pressed-emit', this.enterPressedC);
      } else {
        this.binaryToDec();
      }
    }
  },
  watch: {
    binaryInputC: function () {
      // this.binaryToDec();
      this.keymonitor(event);
      // this.enterPressed();
      // console.log('watcher in AppQuestionb3.vue has run');
    }
    /* enterPressedC: function () {
      this.binaryInputC();
      this.binaryToDec();
      this.enterPressed();
      // this.enterPressed();
    } */
  }
};
</script>

<style>

</style>
